import { render, staticRenderFns } from "./Protokoll.vue?vue&type=template&id=3db561f7&scoped=true"
import script from "./Protokoll.vue?vue&type=script&lang=js"
export * from "./Protokoll.vue?vue&type=script&lang=js"
import style0 from "./Protokoll.vue?vue&type=style&index=0&id=3db561f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db561f7",
  null
  
)

export default component.exports